import { useAuthentication } from "@/Slices/authenticationSlice";
import { useEffect } from "react";
import { clearSlices } from "@/Helpers/clearSlices";

function ResetScreen() {
  const { signOut } = useAuthentication();
  useEffect(function () {
    clearSlices();
    signOut();
  }, []);

  return <></>;
}

export default ResetScreen;
